import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import { useShowTileForm } from '../../lib/redux/hooks/useShowTileForm';
import TileForm from './TileForm';

const FormContainer = () => {
  const { showTileForm, tileData } = useSelector(state => state.tileForm);
  const { closeForm } = useShowTileForm();

  return (
    showTileForm && (
      <Wrapper>
        <TileForm tileData={tileData} />
        <CloseIcon onClick={() => closeForm()} />
      </Wrapper>
    )
  );
};

export default FormContainer;

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: ${themeGet('colors.background')};
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 100px 0;
  overflow: auto;
`;

const CloseIcon = styled.i`
  cursor: pointer;
`;

CloseIcon.defaultProps = {
  className: 'fa-light fa-circle-xmark'
};
